<div class="ps-4 pe-4 pt-4 pb-0">
  <div class="row">
    <div class="col text-end m-2">
      <button class="btn btn-primary ms-2" (click)="goBack()"><fa-icon [icon]="faAngleLeft"></fa-icon> Indietro</button>
    </div>
  </div>
</div>

